import { Link } from '@spotnana/blocks/src/Link';
import { useTranslation } from 'react-i18next';

interface CvvDocLinkProps {
  cvvDocLink: string | undefined;
}
export const CvvDocLink = ({ cvvDocLink }: CvvDocLinkProps) => {
  const { t: tt } = useTranslation('WEB');

  return (
    <Link rel="noreferrer noopener" target="_blank" data-testid="cvv-doc-link" href={cvvDocLink} key={tt('here')}>
      {tt('here')}
    </Link>
  );
};
